import { createApp } from 'vue'
import App from './pages/App.vue'
import router from './routers'

import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import InputText from '@/components/form/InputText.vue'
import TextArea from '@/components/form/TextArea.vue'
import InputRadio from '@/components/form/InputRadio.vue'
import InputCheckbox from '@/components/form/InputCheckbox.vue'
import SelectBox from '@/components/form/SelectBox.vue'
import ComboBox from '@/components/form/ComboBox.vue'
import InputFile from '@/components/form/InputFile.vue'
import InputFiles from '@/components/form/InputFiles.vue'
import DownloadFile from '@/components/form/DownloadFile.vue'
import DownloadFiles from '@/components/form/DownloadFiles.vue'
import DatePicker from '@/components/form/DatePicker.vue'
import DateTimePicker from '@/components/form/DateTimePicker.vue'
import MonthPicker from '@/components/form/MonthPicker.vue'
import TimePicker from '@/components/form/TimePicker.vue'
import ScrollTable from '@/components/common/ScrollTable.vue'
import ScrollTabs from '@/components/common/ScrollTabs.vue'
import Modal from '@/components/common/Modal.vue'
import Loading from '@/components/common/Loading.vue'
import { createPinia } from 'pinia'
import { useAuthStore } from './store/auth'
import { useOperationSupportStore } from './store/operation-support'
dayjs.locale('ja')

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.provide('dayjs', dayjs)
app.provide('swal', VueSweetalert2)

app.component('input-text', InputText)
app.component('input-textarea', TextArea)
app.component('input-radio', InputRadio)
app.component('input-checkbox', InputCheckbox)
app.component('select-box', SelectBox)
app.component('combo-box', ComboBox)
app.component('input-file', InputFile)
app.component('input-files', InputFiles)
app.component('download-file', DownloadFile)
app.component('download-files', DownloadFiles)
app.component('date-picker', DatePicker)
app.component('datetime-picker', DateTimePicker)
app.component('month-picker', MonthPicker)
app.component('time-picker', TimePicker)
app.component('scroll-table', ScrollTable)
app.component('scroll-tabs', ScrollTabs)
app.component('modal', Modal)
app.component('loading', Loading)

app.mount('#app')

// エントリーポイントへのアクセスをネイティブアプリへ通知する
try {
  window.VueAppEntry.postMessage('')
} catch {
  // ブラウザでは失敗するので潰す
}

window.flutterMessage =
  async (
    userId: number | null,
    accessToken: string | null,
    device: string | null,
    os: string | null,
    osVersion: string | null,
    appVersion: string | null,
    buildNumber: string | null = null, // 1.1.0では引数として渡していないのでデフォルト値を設定
  ) => {
    const opSupportStore = useOperationSupportStore()
    await opSupportStore.setAppInfo(device, os, osVersion, appVersion, buildNumber ? parseInt(buildNumber, 10) : null)

    const authStore = useAuthStore()
    await authStore.setTokenLoginInfo(userId, accessToken);
  };